import AngleRight from "@icons/angle-right.svg?react";
import Promoted from "@icons/promoted.svg?react";
import { t } from "@lingui/core/macro";

import { trackMarketplaceItemClick } from "@/common/components/mixpanel/mixpanel-tracking";
import { SearchParamsLink } from "@/common/components/search-params-link/search-params-link";

import { PROMOTIONAL_OFFER_SLUG } from "../marketplace-subcategory.utils";

const PromotionalOfferCard = () => {
  return (
    <SearchParamsLink
      className="w-full flex items-center justify-between"
      onMouseDown={() => {
        trackMarketplaceItemClick({ id: PROMOTIONAL_OFFER_SLUG });
      }}
      to={PROMOTIONAL_OFFER_SLUG}
    >
      <h2 className="font-bold text-xl flex gap-4 items-center w-full p-4 rounded-2xl text-can-midnight-steel shadow-[2px_4px_16px_0px_rgba(122,128,147,0.35)]">
        <Promoted className="w-6 h-6 shrink-0" />
        <span>{t`Akční nabídka`}</span>
        <AngleRight className="w-6 h-6 shrink-0 [&_path]:fill-can-midnight-steel ml-auto" />
      </h2>
    </SearchParamsLink>
  );
};

export { PromotionalOfferCard };
